import { render, staticRenderFns } from "./ScheduleBadges.vue?vue&type=template&id=1bdf65e7&scoped=true"
import script from "./ScheduleBadges.vue?vue&type=script&lang=js"
export * from "./ScheduleBadges.vue?vue&type=script&lang=js"
import style0 from "./ScheduleBadges.vue?vue&type=style&index=0&id=1bdf65e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdf65e7",
  null
  
)

export default component.exports